import { defineComponent, computed, ref, watch } from "vue";
import IconButton from "../common/base/IconButton.vue.mjs";
import AIIcon from "../common/icons/AIIcon.vue.mjs";
import AITranscription from "../common/icons/AITranscription.vue.mjs";
import AISubtitlesIcon from "../common/icons/AISubtitles.vue.mjs";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import { useI18n } from "../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import { useRoomOverlayHooks, OverlayMap } from "../RoomOverlay/useRoomOverlayHooks.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AIControl",
  setup(__props) {
    const { toggleOverlayVisibility } = useRoomOverlayHooks();
    const { t } = useI18n();
    const AIControlConfig = roomService.getComponentConfig("AIControl");
    const { basicStore } = roomService;
    const isSidebarOpen = computed(() => basicStore.isSidebarOpen);
    const sidebarName = computed(() => basicStore.sidebarName);
    const showToolBox = ref(false);
    const showSubtitles = ref(false);
    watch(isSidebarOpen, (newValue) => {
      showToolBox.value = newValue && false;
    });
    function toggleToolBox() {
      showToolBox.value = !showToolBox.value;
    }
    const toggleAITranscription = () => {
      if (basicStore.setSidebarOpenStatus && basicStore.sidebarName === "aiTranscription") {
        basicStore.setSidebarOpenStatus(false);
        basicStore.setSidebarName("");
        return;
      }
      basicStore.setSidebarOpenStatus(true);
      basicStore.setSidebarName("aiTranscription");
      showToolBox.value = false;
    };
    const openAISubtitles = () => {
      showSubtitles.value = !showSubtitles.value;
      showToolBox.value = false;
      toggleOverlayVisibility(OverlayMap.AISubtitlesOverlay, showSubtitles.value);
    };
    return { __sfc: true, toggleOverlayVisibility, t, AIControlConfig, basicStore, isSidebarOpen, sidebarName, showToolBox, showSubtitles, toggleToolBox, toggleAITranscription, openAISubtitles, IconButton, AIIcon, AITranscription, AISubtitlesIcon, SvgIcon };
  }
});
export {
  _sfc_main as default
};
